<template>
  <div class="data-management-container">
    <!-- 顶部操作区 -->
    <div class="operation-header" style="width: 62%">
      <el-input
        v-model="searchText"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 4 }"
        placeholder="请输入账户id，一行一个"
        class="search-input"
      />
      <el-select
        v-model="cookieRegion"
        placeholder="请选择地区"
      >
        <el-option label="浙江" value="zhejiang" />
        <el-option label="福建" value="fujian" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">
        查询
      </el-button>
      <el-button type="success" icon="el-icon-circle-plus" @click="showAddDialog">
        添加事件源
      </el-button>
      <el-button
        type="warning"
        icon="el-icon-download"
        @click="exportToExcel"
        :disabled="tableData.length === 0"
      >
        导出Excel
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      v-loading="loading"
    >

      <el-table-column prop="uuid" label="uuid" width="120" />
      <el-table-column label="事件源类型" width="180">
        <template slot-scope="scope">
    <span>
      <!-- 根据 type 字段的值显示汉字 -->
      {{ formatType(scope.row.type) }}
    </span>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="事件源id" width="220" />
      <el-table-column prop="name" label="事件源名称" />
      <el-table-column prop="packageName" label="包名" />
    </el-table>

    <!-- 添加数据源弹窗 -->
    <el-dialog
      title="批量添加事件源"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleCloseDialog"
    >
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="formRules"
        label-width="120px"
        label-position="right"
      >
        <!-- 新增：地区选择 -->
        <el-form-item label="选择地区：" prop="region">
          <el-select
            v-model="formData.region"
            placeholder="请选择地区"
          >
            <el-option label="浙江" value="zhejiang" />
            <el-option label="福建" value="fujian" />
          </el-select>
        </el-form-item>

        <el-form-item label="事件源类型：" prop="sourceType">
          <el-select
            v-model="formData.sourceType"
            placeholder="请选择"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="formData.sourceType!==2" :label="packageLabel" prop="packageName">
          <el-input
            v-model="formData.packageName"
            :placeholder="packagePlaceholder"
          />
        </el-form-item>

        <el-form-item  v-if="formData.sourceType!==2"  label="事件源名称：" prop="eventName">
          <el-input
            v-model="formData.eventName"
            placeholder="请输入事件源名称"
          />
        </el-form-item>

        <el-form-item label="账户id：" prop="batchData">
          <el-input
            v-model="formData.batchData"
            type="textarea"
            :rows="5"
            placeholder="每行一条数据"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
// 新增依赖引入
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      searchText: '',
      tableData: [],
      loading: false,
      dialogVisible: false,
      zjcookie: '', // 浙江的 Cookie
      fjcookie: '', // 福建的 Cookie
      cookieRegion:'',
      formData: {
        region: '', // 新增：地区选择
        sourceType: '',
        packageName: '',
        eventName: '',
        batchData: ''
      },
      typeOptions: [
        { label: '应用', value: 1 },
        { label: '网址', value: 2 },
        { label: '快应用', value: 3 }
      ],
      formRules: {
        region: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        sourceType: [
          { required: true, message: '请选择事件源类型', trigger: 'change' }
        ],
        packageName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        eventName: [
          { required: true, message: '请输入事件源名称', trigger: 'blur' }
        ],
        batchData: [
          { validator: this.validateBatchData, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.fetchHdCookieData();
  },
  computed: {
    packageLabel() {
      const labels = {
        1: '应用包名：',
        2: '网站域名：',
        3: '快应用包名：'
      };
      return labels[this.formData.sourceType] || '包名：';
    },
    packagePlaceholder() {
      const placeholders = {
        1: '请输入应用包名（如：com.example.app）',
        2: '',
        3: '请输入快应用包名'
      };
      return placeholders[this.formData.sourceType] || '请输入包名';
    }
  },
  methods: {
    formatType(type) {
      switch (type) {
        case 1:
          return '应用';
        case 2:
          return '网址';
        case 3:
          return '快应用';
        default:
          return '未知';  // 处理其他类型或者未定义的情况
      }
    },
    // 新增导出方法
    exportToExcel() {
      // 1. 准备数据
      const data = this.processExportData();

      // 2. 创建工作簿
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "事件源列表");

      // 3. 生成文件并保存
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, `事件源_${new Date().toLocaleDateString()}.xlsx`);
    },

    // 数据处理方法
    processExportData() {
      // 字段映射表
      const fieldMap = {
        uuid: 'uuid',
        type:'事件源类型',
        code: '事件源id',
        name: '事件源名称',
        packageName: '包名',
      };


      return this.tableData.map(item => {
        const formattedItem = {};
        Object.keys(fieldMap).forEach(key => {
          if (item[key] !== undefined) {
            // 处理特殊字段
            let value = item[key];


            if (key === 'type') {
              value = this.formatType(item[key]);
            }
            formattedItem[fieldMap[key]] = value;
          }
        });
        return formattedItem;
      });
    },
    // 转换 type 字段为中文
    formatType1(type) {
      const typeMapping = {
        1: '应用',
        2: '网址',
        3: '快应用'
      };
      return typeMapping[type] || '未知类型';  // 默认返回 "未知类型" 如果 type 不在映射中
    },
    // 地区值转换
    getRegionName(value) {
      const regions = {
        zhejiang: '浙江',
        fujian: '福建'
      };
      return regions[value] || '未知地区';
    },
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('事件获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        this.fjcookie = response.data.data.records[1].hdcookie
        await       this.getData()

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },

    handleSearch() {

      // 处理输入的数据，去除空行
      const selectDatas = this.searchText.split('\n')
        .filter(line => line.trim())

      if (selectDatas.length <=0){
        this.$message.error('请输入uuid')
        return false
      }
      // 根据 region 选择 cookie
      if (this.cookieRegion == ''){
        this.$message.error('请先选择账号所属区域')
        return false
      }


      this.loading = true;

      const selectCookie = this.cookieRegion === 'zhejiang' ? this.zjcookie : this.fjcookie;

      // 调用异步函数
      this.fetchData(selectDatas, selectCookie);
    },
    async fetchData(selectDatas, selectCookie) {
      let mergedData = [];  // 用于存储合并后的数据

      // 遍历 selectDatas 发送请求
      for (let i = 0; i < selectDatas.length; i++) {
        try {
          const encodedCookie = btoa(`${selectCookie}; b_marketing_subid=${selectDatas[i]}`);
          const res = await axios.get(`https://control.zjwec.cn/api/vivo/queryEventData?cookie=${encodedCookie}`);

          // 获取返回的对象数组
          const data = res.data.data;

          // 为每个对象添加 uuid 属性
          const dataWithUuid = data.map(d => ({
            ...d,  // 保留原有的属性
            uuid: selectDatas[i]  // 添加 uuid 属性
          }));

          // 合并数据
          mergedData = mergedData.concat(dataWithUuid);

        } catch (error) {
          console.error('请求失败:', error);
        }
      }

      // 更新 tableData 和 loading 状态
      this.tableData = mergedData;
      this.loading = false;
    },
    showAddDialog() {
      this.dialogVisible = true;
    },
    handleTypeChange() {
      this.formData.packageName = '';
    },
    // handleSubmit() {
    //   this.$refs.dataForm.validate(valid => {
    //     if (valid) {
    //       // 根据选择的地区输出对应的 Cookie
    //       var regionCookie = this.formData.region === 'zhejiang' ? this.zjcookie : this.fjcookie;
    //
    //       const datas  =this.parseBatchData()
    //       for (let i = 0; i < datas.length; i++) {
    //
    //         const requestData = {
    //           cookie:regionCookie+"; b_marketing_subid="+datas[i],
    //           type:this.formData.sourceType,
    //           packageName:this.formData.packageName,
    //           name:this.formData.eventName,
    //         }
    //         axios.post('https://control.zjwec.cn/api/vivo/sendEventData', requestData).then(res=>{
    //
    //           if (res.data.message == '操作成功'){
    //
    //
    //         axios.get('https://control.zjwec.cn/api/vivo/queryEventData?cookie='+regionCookie+"; b_marketing_subid="+datas[i]).then(res=>{
    //
    //           const targetObject = res.data.data.find(item => item.name === this.formData.eventName);
    //
    //           axios.post('http://localhost:9998/api/vivo/sendBatchEventData', {
    //                 cookie:regionCookie+"; b_marketing_subid="+datas[i],
    //                 srcId: targetObject.code
    //               }).then(res=>{
    //             if (res.data.message == '操作成功'){
    //               this.$message.success(datas[i]+"创建数据源成功")
    //             }else{
    //               this.$message.error("创建数据源失败")
    //             }
    //             })
    //         })
    //           }else{
    //             this.$message.error("创建数据源失败")
    //           }
    //
    //         })
    //       }
    //       this.dialogVisible = false;
    //     }
    //   });
    // },
    handleSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          // 根据选择的地区输出对应的 Cookie
          const regionCookie = this.formData.region === 'zhejiang' ? this.zjcookie : this.fjcookie;
          const datas = this.parseBatchData();

          // 使用 async/await 处理异步请求
          this.submitData(datas, regionCookie);
        }
      });
    },

    async submitData(datas, regionCookie) {
      try {
        for (let i = 0; i < datas.length; i++) {
          const requestData = {
            cookie: `${regionCookie}; b_marketing_subid=${datas[i]}`,
            type: this.formData.sourceType,
            packageName: this.formData.sourceType == 2 ? '': this.formData.packageName,
            name:  this.formData.sourceType == 2 ? '网址': this.formData.eventName,
          };

          const postRes = await this.sendEventData(requestData);
          if (postRes.data.message !== '操作成功') {
            this.$message.error("创建事件源失败");
            continue;  // 如果请求失败，跳过当前循环
          }

          const queryRes = await this.queryEventData(regionCookie, datas[i]);
          const targetObject = queryRes.data.data.find(item =>
            item.name === (this.formData.sourceType === 2 ? '网址' : this.formData.eventName)
          );

          if (!targetObject) {
            this.$message.error("未找到目标对象");
            continue;
          }

          const batchRes = await this.sendBatchEventData(regionCookie, datas[i], targetObject.code);
          if (batchRes.data.message === '操作成功') {
            this.$message.success(`${datas[i]} 创建事件源成功`);
          } else {
            this.$message.error("创建事件源失败");
          }
        }
        this.dialogVisible = false;
      } catch (error) {
        this.$message.error("操作失败：" + error.message);
      }
    },

// 封装发送 EventData 的请求
    sendEventData(requestData) {
      return axios.post('https://jqsxm.zjwec.cn/api/vivo/sendEventData', requestData);
    },

// 封装查询 EventData 的请求
    async queryEventData(regionCookie, subId) {
      const encodedCookie = btoa(`${regionCookie}; b_marketing_subid=${subId}`);
      const url = `https://jqsxm.zjwec.cn/api/vivo/queryEventData?cookie=${encodedCookie}`;
      return axios.get(url);

    }
    ,

// 封装发送批量 EventData 的请求
    sendBatchEventData(regionCookie, subId, srcId) {
      return axios.post('https://jqsxm.zjwec.cn/api/vivo/sendBatchEventData', {
        cookie: `${regionCookie}; b_marketing_subid=${subId}`,
        srcId: srcId
      });
    },
    parseBatchData() {
      return this.formData.batchData
        .split('\n')
        .filter(line => line.trim())

    },
    handleCloseDialog() {
      this.$refs.dataForm.resetFields();
    },
    validateBatchData(rule, value, callback) {
      const lines = value.split('\n').filter(l => l.trim());
      if (lines.length === 0) return callback();


      const isValid = lines.every(line => {
        const trimmed = line.trim(); // 去掉前后空格
        return trimmed.length > 0 && /^[a-zA-Z0-9]+$/.test(trimmed); // 检查是否只包含字母或数字
      });

      isValid
        ? callback()
        : callback(new Error('注意检查格式'));
    },

  }
};
</script>

<style scoped>
.data-management-container {
  padding: 20px;
  background: #f5f7fa;
}

.operation-header {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-input {
  flex: 1;
}

.search-input ::v-deep .el-textarea__inner {
  resize: none;
  line-height: 1.5;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/login/DataSourse1.vue